export type PostLoggingAccessParams = {
	actionType: ActionTypeLoggingAccessEnum;
	accessReference: string;
};

export enum ActionTypeLoggingAccessEnum {
	HOME = '1',
	CONCIERGE = '2',
	EXAMS = '3',
	DOCTOR_VISIT = '4',
	OPINIONS = '5',
	PRESCRIPTIONS = '6',
	PROCEDURES = '7',
	EXAMS_RESULTS = '8',
}

export type PostLoggingAccessModel = {
	sucesso: boolean;
};

export interface PostLoggingAccess {
	post: (params: PostLoggingAccessParams) => Promise<PostLoggingAccessModel>;
}
